"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.containerElementTypes = exports.isStyleableWidget = exports.isAlignableWidget = exports.isResizeableWidget = exports.isContainerManagedWidget = exports.getGenericConfigByType = exports.getConfigByType = exports.createContentLoopBodyNode = exports.isInlineWidget = exports.configs = void 0;
var slate_1 = require("slate");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var slate_2 = require("slate");
var Utils_1 = require("../Utils");
var BoxColumn_1 = require("../Widgets/BoxWidget/BoxColumn");
var AccordionBody_1 = require("../Widgets/AccordionWidget/AccordionBody");
var AccordionHeading_1 = require("../Widgets/AccordionWidget/AccordionHeading");
var SideBySideColumn_1 = require("../Widgets/SideBySideWidget/SideBySideColumn");
var ContentLoopBodyRegistry_1 = require("../Widgets/ContentLoopWidget/ContentLoopBodyRegistry");
var TableRow_1 = require("../Widgets/TableWidget/TableRow");
var TableCell_1 = __importDefault(require("../Widgets/TableWidget/TableCell"));
var RepeatingTableRow_1 = __importDefault(require("../Widgets/TableWidget/RepeatingTableRow"));
var TableRowContext_1 = require("../Widgets/TableWidget/TableRowContext");
var Chevron_1 = require("./Widgets/Chevron");
var Box_1 = require("./Widgets/Box");
var HorizontalRule_1 = require("./Widgets/HorizontalRule");
var Heading1_1 = require("./Widgets/Heading1");
var Heading2_1 = require("./Widgets/Heading2");
var Paragraph_1 = require("./Widgets/Paragraph");
var ListItem_1 = require("./Widgets/ListItem");
var BlockQuote_1 = require("./Widgets/BlockQuote");
var Video_1 = require("./Widgets/Video");
var ROICalculator_1 = require("./Widgets/ROICalculator");
var QuoteSummary_1 = require("./Widgets/QuoteSummary");
var Button_1 = require("./Widgets/Button");
var Embed_1 = require("./Widgets/Embed");
var GoogleMaps_1 = require("./Widgets/GoogleMaps");
var Image_1 = require("./Widgets/Image");
var Variable_1 = require("./Widgets/Variable");
var Table_1 = require("./Widgets/Table");
var Accordion_1 = require("./Widgets/Accordion");
var SideBySide_1 = require("./Widgets/SideBySide");
var ContentLoop_1 = require("./Widgets/ContentLoop");
var Layout_1 = require("./Widgets/Layout");
var LayoutColumnWidget_1 = require("../Widgets/Layout/LayoutColumnWidget");
var makeContainerManagedConfig = function (config) { return config; };
exports.configs = [
    Chevron_1.chevronConfig,
    Box_1.boxConfig,
    HorizontalRule_1.horizontalRuleConfig,
    Heading1_1.heading1Config,
    Heading2_1.heading2Config,
    Paragraph_1.paragraphConfig,
    ListItem_1.listItemConfig,
    BlockQuote_1.blockQuoteConfig,
    QuoteSummary_1.quoteSummaryConfig,
    Video_1.videoWidgetConfig,
    Button_1.buttonConfig,
    Embed_1.embedWidgetConfig,
    ROICalculator_1.roiCalculatorConfig,
    GoogleMaps_1.googleMapsWidgetConfig,
    Image_1.imageWidgetConfig,
    Table_1.tableConfig,
    Accordion_1.accordionConfig,
    SideBySide_1.sideBySideConfig,
    ContentLoop_1.contentLoopConfig,
    Layout_1.layoutConfig,
    Variable_1.variableConfig,
];
var inlineConfigs = [Variable_1.variableConfig];
var isInlineWidget = function (element) {
    return !!inlineConfigs.find(function (inline) { return inline.type === element.type; });
};
exports.isInlineWidget = isInlineWidget;
var createContentLoopBodyNode = function () {
    return { children: [(0, Paragraph_1.createParagraphNode)()], type: "contentLoopBody", isVoid: false };
};
exports.createContentLoopBodyNode = createContentLoopBodyNode;
var contentLoopBodyConfig = makeContainerManagedConfig({
    node: {},
    nodeType: "layoutElement",
    type: "contentLoopBody",
    editorRender: ContentLoopBodyRegistry_1.ContentLoopBody,
    validContainers: ["contentLoop"],
    width: "full-width",
    normalizeWidget: function (node, path, editor, schema) {
        var _a, _b, _c;
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (typeof currChild === "undefined" || slate_1.Text.isText(currChild)) {
                slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                return true;
            }
            if (!((_b = (_a = (0, exports.getConfigByType)("contentLoopBody").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
                at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
            });
            return true;
        }
        return false;
    },
    containerNodeConfiguration: {
        validChildren: [],
        showWidgetAdder: true,
        supportWideWidgets: true,
    },
});
var layoutColumnConfig = makeContainerManagedConfig({
    node: {},
    nodeType: "layoutElement",
    type: "layoutColumn",
    editorRender: LayoutColumnWidget_1.LayoutColumnWidget,
    validContainers: ["layout"],
    width: "full-width",
    normalizeWidget: function (node, path, editor, schema) {
        var _a, _b, _c;
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (typeof currChild === "undefined" || slate_1.Text.isText(currChild)) {
                slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                return true;
            }
            if (!((_b = (_a = (0, exports.getConfigByType)("layoutColumn").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
                at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
            });
            return true;
        }
        return false;
    },
    containerNodeConfiguration: {
        validChildren: [],
        showWidgetAdder: true,
    },
});
var containerManagedConfigs = [
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "boxColumn",
        editorRender: BoxColumn_1.BoxColumn,
        validContainers: ["box"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (!currChild) {
                    continue;
                }
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("boxColumn").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: true,
        },
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "tableRow",
        editorRender: TableRow_1.TableRowWidget,
        validContainers: ["table"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var table = (0, Utils_1.checkAncestors)(editor, path, function (c) { return slate_2.Element.isElement(c) && c.type === "table"; });
            if (table) {
                for (var childIdx = 0; childIdx < node.children.length; childIdx++) {
                    var child = node.children[childIdx];
                    if (!slate_1.Element.isElement(child) || child.type !== "tableCell") {
                        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [childIdx], false) });
                        return true;
                    }
                }
                if (node.children.length < table[0].data.columns) {
                    slate_1.Transforms.insertNodes(editor, (0, Table_1.createTableCellNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length], false) });
                    return true;
                }
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: false,
            hasContainerManagedChildren: true,
        },
        selfManagedRender: true,
        widgetContextProvider: TableRowContext_1.TableRowContextProvider,
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "tableRepeatingRow",
        editorRender: RepeatingTableRow_1.default,
        validContainers: ["table"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var table = (0, Utils_1.checkAncestors)(editor, path, function (c) { return slate_2.Element.isElement(c) && c.type === "table"; });
            if (table) {
                for (var childIdx = 0; childIdx < node.children.length; childIdx++) {
                    var child = node.children[childIdx];
                    if (!slate_1.Element.isElement(child) || child.type !== "tableCell") {
                        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [childIdx], false) });
                        return true;
                    }
                }
                if (node.children.length < table[0].data.columns) {
                    slate_1.Transforms.insertNodes(editor, (0, Table_1.createTableCellNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length], false) });
                    return true;
                }
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: false,
            hasContainerManagedChildren: true,
        },
        selfManagedRender: true,
        widgetContextProvider: TableRowContext_1.TableRowContextProvider,
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "tableCell",
        editorRender: TableCell_1.default,
        validContainers: ["tableRow", "tableRepeatingRow"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (!currChild) {
                    continue;
                }
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("tableCell").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: false,
        },
        selfManagedRender: true,
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "accordionHeading",
        editorRender: AccordionHeading_1.AccordionHeadingRegistryWidget,
        validContainers: ["accordion"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            if (node.children && node.children.length > 1) {
                var _d = __read((0, Utils_1.getNext)(editor, path, function (curr) {
                    return slate_2.Element.isElement(curr) && curr.type === "accordionBody";
                }), 2), accordionBody = _d[0], accordionBodyPath = _d[1];
                if (slate_2.Element.isElement(node.children[1]) && slate_1.Editor.isEmpty(editor, node.children[1])) {
                    slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
                    (0, Utils_1.moveToStartOfNextText)(editor);
                }
                else {
                    slate_1.Transforms.moveNodes(editor, {
                        at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length - 1], false),
                        to: __spreadArray(__spreadArray([], __read(accordionBodyPath), false), [0], false),
                    });
                }
                return true;
            }
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (!currChild) {
                    continue;
                }
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("accordionHeading").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: false,
            allowDragAndDropChildren: false,
        },
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "accordionBody",
        editorRender: AccordionBody_1.AccordionBodyRegistryWidget,
        validContainers: ["accordion"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (!currChild) {
                    continue;
                }
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("accordionBody").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: true,
        },
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "sideBySideColumn",
        editorRender: SideBySideColumn_1.SideBySideColumn,
        validContainers: ["sideBySide"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (!currChild) {
                    continue;
                }
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("sideBySideColumn").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, Paragraph_1.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: true,
        },
    }),
    contentLoopBodyConfig,
    layoutColumnConfig,
];
var getConfigByType = function (type) {
    var e_1, _a, e_2, _b;
    try {
        for (var configs_1 = __values(exports.configs), configs_1_1 = configs_1.next(); !configs_1_1.done; configs_1_1 = configs_1.next()) {
            var config = configs_1_1.value;
            if (config.type === type) {
                return config;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configs_1_1 && !configs_1_1.done && (_a = configs_1.return)) _a.call(configs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var containerManagedConfigs_1 = __values(containerManagedConfigs), containerManagedConfigs_1_1 = containerManagedConfigs_1.next(); !containerManagedConfigs_1_1.done; containerManagedConfigs_1_1 = containerManagedConfigs_1.next()) {
            var config = containerManagedConfigs_1_1.value;
            if (config.type === type) {
                return config;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (containerManagedConfigs_1_1 && !containerManagedConfigs_1_1.done && (_b = containerManagedConfigs_1.return)) _b.call(containerManagedConfigs_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    throw new Error("Config with type ".concat(type, " not registered"));
};
exports.getConfigByType = getConfigByType;
function getGenericConfigByType(type, includeContainerManagedWidgets) {
    if ((0, exports.isContainerManagedWidget)(type) && !includeContainerManagedWidgets) {
        return undefined;
    }
    try {
        return (0, exports.getConfigByType)(type);
    }
    catch (_a) {
        return undefined;
    }
}
exports.getGenericConfigByType = getGenericConfigByType;
var isContainerManagedWidget = function (type) {
    return !!containerManagedConfigs.find(function (f) { return f.type === type; });
};
exports.isContainerManagedWidget = isContainerManagedWidget;
var isResizeableWidget = function (widget) {
    try {
        return !!(0, GetTraitConfig_1.getTraitConfig)({ widgetType: widget.type, traitName: "resizeable" });
    }
    catch (_a) {
        return false;
    }
};
exports.isResizeableWidget = isResizeableWidget;
var isAlignableWidget = function (widget) {
    try {
        return !!(0, GetTraitConfig_1.getTraitConfig)({ widgetType: widget.type, traitName: "alignable" });
    }
    catch (_a) {
        return false;
    }
};
exports.isAlignableWidget = isAlignableWidget;
var isStyleableWidget = function (widget) {
    try {
        return !!(0, GetTraitConfig_1.getTraitConfig)({ widgetType: widget.type, traitName: "styleable" });
    }
    catch (_a) {
        return false;
    }
};
exports.isStyleableWidget = isStyleableWidget;
var containerConfigs = __spreadArray(__spreadArray([], __read(containerManagedConfigs), false), [
    Table_1.tableConfig,
    Accordion_1.accordionConfig,
    Box_1.boxConfig,
    SideBySide_1.sideBySideConfig,
    contentLoopBodyConfig,
    Layout_1.layoutConfig,
], false);
exports.containerElementTypes = containerConfigs.map(function (e) { return e.type; });
